export const PARENT_INVITE_TOKEN_KEY = 'quillnoteParentInvite'
const PARENT_INVITE_CACHE_KEY = 'quillnoteActiveParentInvite'

export function rememberParentInviteToken (token) {
  if (!token || typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(PARENT_INVITE_TOKEN_KEY, token)
}

export function readParentInviteToken () {
  if (typeof sessionStorage === 'undefined') return ''
  return sessionStorage.getItem(PARENT_INVITE_TOKEN_KEY) || ''
}

export function clearParentInviteToken () {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(PARENT_INVITE_TOKEN_KEY)
}

export function readCachedParentInvite () {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const parsed = JSON.parse(sessionStorage.getItem(PARENT_INVITE_CACHE_KEY) || 'null')
    if (!parsed || typeof parsed.urlPath !== 'string' || typeof parsed.expiresAt !== 'string') {
      return null
    }
    if (Date.parse(parsed.expiresAt) <= Date.now()) return null
    return parsed
  } catch (error) {
    return null
  }
}

export function cacheParentInvite (invite) {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(PARENT_INVITE_CACHE_KEY, JSON.stringify({
    urlPath: invite.urlPath,
    expiresAt: invite.expiresAt
  }))
}
